import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyInviteService } from '@core/services/company-invite.service';

/**
 * Page shown when a user follows an unsubscribe link. Reads the `inviteCode`
 * query parameter, validates it, and unsubscribes the associated invite,
 * surfacing any error to the user via {@link redemptionMessage}.
 */
@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrl: './unsubscribe.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UnsubscribeComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private inviteService = inject(CompanyInviteService);

  /** Message displayed to the user describing the unsubscribe outcome or error. */
  redemptionMessage: string = '';
  /** The invite code read from the URL query parameters. */
  inviteCode!: string;
  /** When true, forces the sign-up call-to-action to render in the template. */
  testing = true;

  /**
   * Angular lifecycle hook. Reads the `inviteCode` query parameter; when present
   * and valid, unsubscribes the invite, otherwise sets an explanatory message.
   * @returns void
   */
  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.inviteCode = params['inviteCode'];
      const inviteCode = params['inviteCode'];
      if (inviteCode) {
        // Redeem the invite code
        this.inviteService
          .validateInviteCode(inviteCode)
          .then((res) => {
            if (res) {
              this.inviteService.unsubscribeInvite(inviteCode).then(() => { });
            }
          })
          .catch((error: any) => {
            // Handle redemption error
            this.redemptionMessage =
              'Error redeeming invite code: ' + error.message;
          });
      } else {
        // Handle missing invite code in URL
        this.redemptionMessage = 'No invite code found in the URL.';
      }
    });
  }
}
